import { DatePipe } from '@angular/common';
import { DsDocFilterInterface } from '../interfaces/ds-doc-filter.interface';
import { VisaStatesEnum } from '../enums/visa-states.enum';

export class DsDocFilter {
  /**
   *
   */
  public name__contains?: string;

  /**
   *
   */
  public created_after?: string;

  /**
   *
   */
  public created_before?: string;

  /**
   *
   */
  public tags?: string;

  /**
   *
   */
  public creator_email?: string;

  /**
   *
   */
  public visa__status?: string;

  /**
   *
   */
  public visa__status__strict?: string;

  /**
   *
   */
  public visa__deadline_after?: string;

  /**
   *
   */
  public visa__deadline_before?: string;

  /**
   *
   */
  public visa__past__deadline?: boolean;

  /**
   *
   */
  public has__visa?: boolean;

  /**
   * Creates an instance of DsDocFilter.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsDocFilterInterface) {
    const datePipe = new DatePipe('en-US');
    if (jsonData?.nameContains) this.name__contains = jsonData?.nameContains;
    if (jsonData?.creationDate?.begin) this.created_after = new Date(jsonData.creationDate.begin).toISOString();
    if (jsonData?.creationDate?.end) this.created_before = new Date(jsonData.creationDate.end).toISOString();
    if (jsonData?.tags) this.tags = `${jsonData?.tags}`;
    if (jsonData?.creatorEmail) this.creator_email = jsonData?.creatorEmail;
    this.visa__past__deadline = null;
    this.has__visa = null;
    this.visa__status = jsonData?.visaStatus || null;
    this.visa__status__strict = jsonData?.visaStatus || null;
    if (jsonData?.visaStatus === VisaStatesEnum.LATE) {
      this.visa__past__deadline = true;
      this.visa__status = null;
      this.visa__status__strict = null;
      this.has__visa = true;
    } else if (jsonData?.visaStatus === VisaStatesEnum.NO_VISA) {
      this.has__visa = false;
      this.visa__status = null;
      this.visa__status__strict = null;
    } else if (jsonData?.visaStatus === VisaStatesEnum.OPEN) {
      this.has__visa = true;
      this.visa__status__strict = null;
    } else if (jsonData?.visaStatus) {
      this.has__visa = true;
      this.visa__status = null;
    }
    if (jsonData?.dueDate?.begin) this.visa__deadline_after = datePipe.transform(jsonData.dueDate.begin, 'yyyy-MM-dd');
    if (jsonData?.dueDate?.end) this.visa__deadline_before = datePipe.transform(jsonData.dueDate.end, 'yyyy-MM-dd');
  }
}
